import { createFileRoute } from "@tanstack/react-router";
import ProductHub from "@/pages/ProductHub";
import { hubArticlesQueryOptions } from "@/lib/hubArticles";

export const Route = createFileRoute("/lawn-mowers/")({
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(hubArticlesQueryOptions("lawn-mowers")).catch(() => null);
  },
  component: () => <ProductHub hubSlug="lawn-mowers" />,
});
